import Manajemen from "./components";
export default Manajemen;